(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('TargetAudienceService', TargetAudienceService);

    /** @ngInject */
    function TargetAudienceService(TargetAudienceFactory) {
        var service = {
            listAll: listAll,
            getAllFilters: getAllFilters,
            createTargetAudience: createTargetAudience,
            deleteTargetAudience: deleteTargetAudience,
            findById: findById
        };

        return service;

        function listAll(pageable, params) {
            return TargetAudienceFactory.listAll(pageable, params).$promise;
        }

        function getAllFilters(userLang) {
            return TargetAudienceFactory.getAllFilters({langKey: userLang}).$promise;
        }

        function createTargetAudience(targetAudience) {
            return TargetAudienceFactory.save(targetAudience).$promise;
        }

        function deleteTargetAudience(targetAudienceId) {
            return TargetAudienceFactory.delete({ id: targetAudienceId }).$promise;
        }

        function findById(targetAudienceId, langKey) {
            return TargetAudienceFactory.findById({ id: targetAudienceId, langKey: langKey }).$promise;
        }
    }
})();
